const postTenants = {
  toastr: 'Tenant agregado',
  toastr1: ' fue agregado con éxito',
  toastrError: 'Tenant ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default postTenants;
